// What a person typed into an editable block, read back as inline markdown (decision 034): bold, italic, strike, code and links of
// the browser's own formatting become marks; everything else of a pasted or styled DOM is plain text.

import { inlineToMarkdown, type InlineNode } from '@confdeck/core-shared';

function read(parent: Node): InlineNode[] {
  const out: InlineNode[] = [];
  const text = (v: string) => {
    const last = out[out.length - 1];
    if (last?.t === 'text') last.v += v; else if (v) out.push({ t: 'text', v });
  };
  const wrap = (t: 'b' | 'i' | 's', c: InlineNode[]) => { if (c.length) out.push({ t, c }); };
  parent.childNodes.forEach((n) => {
    if (n.nodeType === Node.TEXT_NODE) { text((n.nodeValue ?? '').replace(/ /g, ' ').replace(/​/g, '')); return; }
    if (n.nodeType !== Node.ELEMENT_NODE) return;
    const el = n as HTMLElement;
    switch (el.tagName) {
      case 'BR': text('\n'); return;
      case 'B': case 'STRONG': wrap('b', read(el)); return;
      case 'I': case 'EM': wrap('i', read(el)); return;
      case 'S': case 'DEL': case 'STRIKE': wrap('s', read(el)); return;
      case 'CODE': if (el.textContent) out.push({ t: 'code', v: el.textContent }); return;
      case 'A': { const c = read(el); const href = el.getAttribute('href'); if (href && c.length) out.push({ t: 'link', href, c }); else c.forEach((x) => (x.t === 'text' ? text(x.v) : out.push(x))); return; }
      // A line the browser wrapped in its own block is a line of this block.
      case 'DIV': case 'P': { if (out.length) text('\n'); read(el).forEach((x) => (x.t === 'text' ? text(x.v) : out.push(x))); return; }
      default: {
        const st = el.style;
        const inner = read(el);
        if (st && (st.fontWeight === 'bold' || Number(st.fontWeight) >= 600)) wrap('b', inner);
        else if (st && st.fontStyle === 'italic') wrap('i', inner);
        else inner.forEach((x) => (x.t === 'text' ? text(x.v) : out.push(x)));
      }
    }
  });
  return out;
}

/** The inline markdown of an element's content; the browser's trailing line break is not text. */
export const domToInline = (el: Node) => inlineToMarkdown(read(el)).replace(/\n$/, '');
